<template>
  <div class="page-main page-border">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Admin</li>
      </ol>
      <h1 class="page-title">Client Usage History</h1>
    </div>
    <div class="page-content">
      <div class="card" v-show="isLoading">
        <div class="card-block">
          <p class="card-text">
            <div class="row">
              <div class="col-md-12 card-stat">
                <loading-indicator></loading-indicator>
              </div>
            </div>
          </p>
        </div>
      </div>
      <div class="card" v-show="!isLoading">
        <Client-usage-history
          v-bind:team="team"
          v-bind:showTitle="false"
          v-on:loadChanged="clientUsageHistoryLoadChanged">
        </Client-usage-history>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ClientUsageHistory from 'components/billings/usages/ClientUsageHistory';
import LoadingIndicator from 'components/LoadingIndicator';

export default {
  components: {
    ClientUsageHistory,
    LoadingIndicator,
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
    isLoading: function() {
      return this.isClientUsageHistoryLoading;
    },
  },
  data: function () {
    return {
      team: null,
      isClientUsageHistoryLoading: false,
    };
  },
  created: function() {
    this.team = this.currentUser.team;
  },
  methods: {
    clientUsageHistoryLoadChanged: function(value) {
      this.isClientUsageHistoryLoading = value;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// ManageClientUsageHistory.vue?2bdea24f